export default __webpack_public_path__ + "static/media/accounting_point_1.3e92ef21.png";